import { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";
import { useSelector } from "react-redux";
import http from "../api/server";
import { GENERATE_QR } from "../api/apiPath";
import Iframe from "react-iframe";
import useGetClientId from "../hooks/useGetClientId";
const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
import Toaster from "./common/Toaster";

export default function QRCodes() {
  const [hideSidebar, setHideSidebar] = useState(true);
  const { userObj } = useSelector((state) => state.user);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [qrResult, setQrResult] = useState(null);

  const [error, setError] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === "" || (Number(value) >= 0 && Number(value) <= 30)) {
      setInputValue(value);
      setError("");
    }
  };

  const handleGenerate = async () => {
    if (!inputValue || inputValue == "0") {
      setError("Please enter valid number of QR codes");
      return;
    }
    console.log(setQrResult);

    try {
      setLoading(true);

      const payload = {
        ClientId: clientObj?.clientId,
        LoggedinUserId: userObj?.userId,
        NumberOfQRCodes: Number(inputValue),
      };

      const response = await http.post(GENERATE_QR, payload, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);

      setPdfUrl(pdfUrl);
      setShowPdfModal(true);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "QRcode.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true);
      }
    } catch (err) {
      console.error("Error generating QR:", err);
      console.log("Something went wrong while generating QR Codes");
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: err.message || "Unknown error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-3">
            <h1 className="page-title">Generate QR Code</h1>

            <input
              type="number"
              min="1"
              max="30"
              value={inputValue}
              onChange={handleChange}
              placeholder="Generate QR Code (1-30)"
              className="form-control w-100 mt-2"
            />
            {error && <span className="formError mt-2">{error}</span>}
            <button
              type="button"
              className="btn btn-primary mt-5"
              onClick={handleGenerate}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate QR Code(s)"}
            </button>

            {qrResult && (
              <div className="mt-4">
                <h5>QR Codes Generated</h5>
                <pre>{JSON.stringify(qrResult, null, 2)}</pre>
              </div>
            )}
          </div>

          <Footer />
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
